import React, { useEffect, useState } from "react";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import BottomMenu from "../../../layout/bottomMenu";
import Calculator from "../../../DistanceCalculator/Calculator";
import MeetingRating from "../../../Rating/Rating";
import { toast } from "react-toastify";
import { useHistory } from 'react-router-dom';

const RmList = ({
  match,
  getLeadFilter,
  leadFilter,
  history,
  saveRatingForHod,
  ratingByHod = [],
  emailDropdownData,
  getEmailDropdown = [],
  getRmViewDetails,
  getRmDetails = [],
  ratingSave,
  savedRating=[],
  activityList,
  activityListDetails = [],

}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterInputList, setFilterInputList] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [isFilterRemove, setIsRemoveFilter] = useState(false);
  const [pageNo, setPage] = useState(1);
  const [userId, setUserId] = useState("");
  const [openRatingModel, setOpenRatingModel] = useState(false);
  // const [expandedCard, setExpandedCard] = useState(null); // State to keep track of expanded card
  const [meetingId, setMeetingId] = useState('');
  const [filterDates, setFilterDates] = useState(null);



  // const handleCardClick = (index) => {
  //   setExpandedCard(expandedCard === index ? null : index); // Toggle expanded state
  // };


  useEffect(() => {
    (async () => {
      setIsLoading(true);
      if(window.localStorage.rm_list_filter){
        setFilterInputList(JSON.parse(window.localStorage.rm_list_filter))
        await getRmViewDetails(1, JSON.parse(window.localStorage.rm_list_filter));
      } else {
        await getRmViewDetails(1);
      }

      setIsLoading(false);
    })();
  }, []);

  const handleFilter = async (key, value, stringValue = "") => {
    const list = [...filterInputList];
    list[0][key] = value;
    setFilterInputList(list);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getRmViewDetails(val?.selected + 1, filterInputList);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await emailDropdownData("junior");
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const filter = localStorage.getItem('rm_list_filter');
    if (filter) {
      const parsedFilter = JSON.parse(filter);
      if (parsedFilter.length > 0 && parsedFilter[0].start_date && parsedFilter[0].end_date) {
        setFilterDates(parsedFilter[0]);
      }
    }
  }, []);


  // useEffect(() => {
  //   if (
  //       ratingByHod?.status_code &&
  //     parseInt(ratingByHod?.status_code) === 200
  //   ) {
  //     toast.success("Rating is marked successfully");

  //     (async () => {
  //       setOpenRatingModel(false);
  //       setIsLoading(true);
  //       // await activityList('lead', match?.params?.id)
  //       setIsLoading(false);
  //     })();
  //   } else if (
  //       ratingByHod?.status_code &&
  //     parseInt(ratingByHod?.status_code) !== 200
  //   ) {
  //     toast.warning(ratingByHod?.message);
  //     setOpenRatingModel(false);
  //   }
  // }, [ratingByHod]);

    const handleSubmitFilter = async () => {
      setOpen(false);
      setIsLoading(true);
      window.localStorage.rm_list_filter = JSON.stringify(filterInputList)
      window.location.reload()
      await getRmViewDetails(1, filterInputList);
      setIsLoading(false);
    };

    const handleRemoveFilter = async (key) => {
      if (key !== "") {
        delete filterInputList[0][key];
        console.log(filterInputList.length)
        if(filterInputList[0].length === 0){
          delete window.localStorage.rm_list_filter
        } else {
          window.localStorage.rm_list_filter = JSON.stringify(filterInputList)
        }
        setFilterInputList(filterInputList);
        setIsLoading(true);
        window.location.reload()
        await getRmViewDetails(localStorage.getItem(1), filterInputList);
        setIsLoading(false);
      }
    };

    useEffect(() => {
      (async () => {
        if (isFilterRemove) {
          setFilterInputList([{}]);
          setIsLoading(true);
          await getRmViewDetails(localStorage.getItem(1), filterInputList);
          setIsLoading(false);
          setIsRemoveFilter(false);
        }
      })();
    }, [isFilterRemove]);


  //   useEffect(() => {
  //     if(savedRating?.status_code && parseInt(savedRating?.status_code) === 200){
  //         toast.success("Rating is marked successfully");

  //         (async ()=> {
  //             setOpenRatingModel(false)
  //             setIsLoading(true)
  //             await activityList('lead', match?.params?.id)
  //             setIsLoading(false)
  //         })()
  //     }else if(savedRating?.status_code && parseInt(savedRating?.status_code) !== 200) {
  //         toast.warning(savedRating?.message);
  //         setOpenRatingModel(false)
  //     }
  // }, [savedRating])


  console.log("Dropdown:", getEmailDropdown);
    

    function formatDate(dateString) {
        if (!dateString) return ''; // Return empty string if dateString is null or undefined
        
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1; // Month is zero-based
        const year = date.getFullYear();
    
        // Pad single digits with leading zero
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;
    
        return formattedDay + '-' + formattedMonth + '-' + year;
    }


    // const handleRateClick = (id) => {
    //   history.push(`/rm-view-activity/${id}`);
    // };
  


  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Reporting Manager View"} history={history} />
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <>
                <div className="d-sm-flex align-items-center justify-content-between">
                  <div className="row col-md-12">
                      <button
                        onClick={() => setOpen(!open)}
                        className="btn btn-sm btn-primary mr-1 btn-filter"
                        type="button"
                      >
                        <i className="fa fa-filter lh-35 pd-3"></i>
                      </button>
                  </div>
                </div>

                {/* Filter View */}
                {filterInputList[0] !== undefined &&
                  Object.keys(filterInputList[0]).length > 0 && (
                    <div className="d-sm-flex align-items-center justify-content-between mb-5">
                      <div className="row pd-filter-div mt-17">
                        <div className="col-md-12 col-sm-12 d-flex">
                          <div className="applied-filter">
                            {Object.keys(filterInputList[0]).map((val, i) => {
                              return (
                                <>
                                  <span className="fd-1">
                                    <span
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {val.replaceAll("_", " ")}
                                    </span>
                                    {" - " + filterInputList[0][val]}
                                    <i
                                      className="bi bi-x-circle"
                                        onClick={(e) => {
                                          handleRemoveFilter(val);
                                        }
                                      }
                                    ></i>
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {/* Filter View End*/}

                <div className="col-md-12 col-sm-12 mt-5">
                  <div className="card shadow mb-4">
                    <div className="card-body">
                      <h4 className="small font-weight-bold text-black-100">
                        <b>Fulfillment% For {filterDates ? `${filterDates.start_date} to ${filterDates.end_date}` : 'Last 30 Days'} (Total Number Of Rated Meetings/Total Number Of Meetings)</b>
                        <span className="float-right">
                          {getRmDetails?.summary?.last_30_days_fulfillment}%
                        </span>
                      </h4>
                      <div className="progress mb-4">
                        {getRmDetails?.summary?.last_30_days_fulfillment !== undefined &&
                          getRmDetails?.summary?.last_30_days_fulfillment < 15 && (
                            <div
                              className="progress-bar bg-danger"
                              role="progressbar"
                              style={{
                                width: `${getRmDetails?.summary?.last_30_days_fulfillment}%`,
                              }}
                              aria-valuenow={getRmDetails?.summary?.last_30_days_fulfillment}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          )}
                        {getRmDetails?.summary?.last_30_days_fulfillment >= 15 &&
                          getRmDetails?.summary?.last_30_days_fulfillment < 40 && (
                            <div
                              className="progress-bar bg-warning"
                              role="progressbar"
                              style={{
                                width: `${getRmDetails?.summary?.last_30_days_fulfillment}%`,
                              }}
                              aria-valuenow={getRmDetails?.summary?.last_30_days_fulfillment}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          )}
                        {getRmDetails?.summary?.last_30_days_fulfillment >= 40 && (
                          <div
                            className="progress-bar bg-success"
                            role="progressbar"
                            style={{
                              width: `${getRmDetails?.summary?.last_30_days_fulfillment}%`,
                            }}
                            aria-valuenow={getRmDetails?.summary?.last_30_days_fulfillment}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        )}
                      </div>

                      <div className="d-flex">
                        <div className="sl text-center">
                          {/* <span className=""><b>Total Rated Meetings(last 30 days)</b></span> */}
                          <span className=""><b>Total Rated Meetings({filterDates ? `${filterDates.start_date} to ${filterDates.end_date}` : 'last 30 days'})</b></span>

                            <span>{getRmDetails?.summary?.total_number_of_rated_meetings_in_last_30_days}</span>
                        </div>
                        <div className="sl text-center ">
                          <span className="cgs"></span>
                        </div>
                        <div className="sl text-center">
                          {/* <span className=""><b>Total Unrated Meetings(last 30 days)</b></span> */}
                          <span className=""><b>Total Unrated Meetings({filterDates ? `${filterDates?.start_date} to ${filterDates?.end_date}` : 'last 30 days'})</b></span>
                           <span>{getRmDetails?.summary?.total_number_of_unrated_meetings_in_last_30_days}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row" id="expanded-card">
                  {/*CARD START*/}
                  {getRmDetails &&
                    getRmDetails?.detail !== undefined &&
                    getRmDetails?.detail?.data?.map((val, i) => {
                      return (
                        <>
                          <div className="col-md-4 col-sm-6">
                            <div className="card-big-shadow">
                              <div
                                className="card card-just-text"
                                data-background=""
                                data-color=""
                                data-radius="none"
                                // onClick={() => handleCardClick(i)}
                              >
                                <div className="content">
                                  <h6 className="category mrg-b-12">
                                    <div className="row">
                                      <div
                                        className="col-10"
                                        style={{
                                          color: "#000",
                                          fontSize: "20px",
                                          textAlign: "left",
                                          paddingLeft: "20px",
                                        }}
                                      >
                                          <span className="">{val?.name}</span>
                                      </div>
                                    </div>
                                    <div className="float-right" style={{
                                            position: "relative",
                                            top: -20,
                                            right: 12
                                        }}>
                                        <span>
                                        {
                                             (val?.module_type === 'Society' || val?.module_type === 'Corporate' || val?.module_type === 'Mall') ? 
                                              <a href={`/v2-opportunity-activity-view/${val?.id}/1`}>
                                                <i className="bi bi-eye" style={{ fontSize: '20px' }} />
                                              </a>
                                            : <a href={`/rm-view-activity/${val?.meeting_id}`}>
                                            <i className="bi bi-eye" style={{ fontSize: '20px' }} />
                                          </a>
                                        }                  
                                        </span>
                                      </div>
                                    <div className="row list-view mt-4">
                                        <div className="mb-flex">
                                          <div className="col-md-4">
                                            <i
                                              className="fa fa-envelope"
                                              style={{ color: "#970f0f" }}
                                              aria-hidden="true"
                                              ></i>
                                            &nbsp;&nbsp;Email:
                                          </div>
                                              {val?.email !== null && (
                                          <div className="col-md-8">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.email}
                                            >
                                              {val?.email}
                                            </span>
                                          </div>
                                          )}
                                        </div>
                                        
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-calendar"
                                              style={{ color: "blue" }}
                                              aria-hidden="true"
                                              ></i>
                                            &nbsp;&nbsp;Meeting Date:
                                          </div>
                                          {val?.meeting_date !== null && (
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.meeting_date}
                                            >
                                            {formatDate(val?.meeting_date)}
                                            </span>
                                          </div>
                                          )}
                                        </div>


                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-clock"
                                              style={{ color: "green" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Meeting Duration:
                                          </div>
                                          {val?.meeting_duration !== null && (
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.meeting_duration}
                                            >
                                              {val?.meeting_duration}
                                            </span>
                                          </div>
                                          )}
                                        </div>

                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-map-pin"
                                              style={{ color: "brown" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;MOM:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                                className="trigger"
                                                data-tooltip-id="1"
                                                title={val?.meta_data[0] && val?.meta_data[0]?.MOM ? val?.meta_data[0]?.MOM : val?.meta_data[0] && val?.meta_data[0]?.remark ?
                                                  val?.meta_data[0]?.remark : val?.description}
                                            >
                                              {val?.meta_data[0] && val?.meta_data[0]?.MOM ? val?.meta_data[0]?.MOM : val?.meta_data[0] && val?.meta_data[0]?.remark ?
                                                  val?.meta_data[0]?.remark : val?.description}
                                            </span>
                                          </div>
                                        </div>

                                      {val?.rating !== null && val?.rating_date !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-calendar"
                                              style={{ color: "orange" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Rating Date:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rating_date}
                                            >
                                              {formatDate(val?.rating_date)}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.rating !== null && val?.rating[0]?.rating !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-star"
                                              style={{ color: "#FFD700" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Rating:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rating[0]?.rating}
                                            >
                                              {val?.rating[0]?.rating}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.rating !== null && val?.rating[0]?.remark !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fas fa-file"
                                              style={{ color: "#8F00FF" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Feedback:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rating[0]?.remark}
                                            >
                                              {val?.rating[0]?.remark}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.rating !== null && val?.rated_by_name !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fas fa-address-book"
                                              style={{ color: "pink" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Rated by name:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rated_by_name}
                                            >
                                              {val?.rated_by_name}
                                            </span>
                                          </div>
                                        </div>
                                      )}

                                      {val?.rating !== null && val?.rated_by_email !== null && (
                                        <div className="mb-flex mt-2">
                                          <div className="col-md-6 col-sm-6">
                                            <i
                                              className="fa fa-envelope"
                                              style={{ color: "#154c79" }}
                                              aria-hidden="true"
                                            ></i>
                                            &nbsp;&nbsp;Rated by email:
                                          </div>
                                          <div className="col-md-6 col-sm-6 l2">
                                            <span
                                              className="trigger"
                                              data-tooltip-id="1"
                                              title={val?.rated_by_email}
                                            >
                                              {val?.rated_by_email}
                                            </span>
                                          </div>
                                        </div>
                                      )}


                                    </div>
                                    <hr />
                                  </h6>
                                </div>
                                {/* {console.log("MeetingID:", val?.id)} */}
                                {/* {expandedCard === i && (

                                )}  */}

                                  <div className="row list-view-links mb-4">
                                    <ul>
                                    <li>
                                    {val?.rating === null &&
                                        <>
                                            <a style={{color: "rgb(149 150 40)"}}
                                                href={`/rm-view-activity/${val?.meeting_id}`}
                                                // onClick={() =>
                                                // {
                                                //     // setOpenRatingModel(true)
                                                //     setMeetingId(val?.meeting_id)
                                                // }
                                                
                                                // }
                                                // onClick={handleRateClick(val?.meeting_id)}
                                            ><i className="fa fa-star"
                                                aria-hidden="true" style={{marginRight:"0.3rem"}}></i>Rate</a>
                                        </>
                                    }
                                    </li>

                                    </ul>
                                  </div>

                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}

                  {getRmDetails &&
                    getRmDetails?.detail !== undefined &&
                    getRmDetails?.detail?.data.length > 0 && (
                      <div className="panel-pagination-col panel-table-pagination">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={
                            getRmDetails?.detail?.total /
                            getRmDetails?.detail?.per_page
                          }
                          forcePage={
                            getRmDetails?.detail?.current_page - 1
                          }
                          pageRangeDisplayed={4}
                          onPageChange={onPageChange}
                          activeClassName={"active"}
                        />
                      </div>
                    )}
                  {getRmDetails &&
                    getRmDetails?.detail !== undefined &&
                    getRmDetails?.detail?.data?.length === 0 && (
                      <>
                        <img
                          src={NotFoundData}
                          className="not-found-data"
                          alt={""}
                        />
                        <div className="text-center" style={{ width: "100%" }}>
                          Data Not Found
                        </div>
                      </>
                    )}
                </div>
                </>
                
              </div>
            </div>
          </div>
        </div>

        <BottomMenu
          open={open}
          setOpen={setOpen}
          handleSubmitFilter={handleSubmitFilter}
          filterContent={{data:[
            {'field' :'date', 'place_holder' : 'Meeting Date', 'values' : ''},
            // {'field' :'text', 'place_holder' : 'Meeting By', 'values' : ''},
            {
              'field': 'dropdown',
              'place_holder': 'Meeting By',
              'values': getEmailDropdown
            },
      
            {'field' :'date', 'place_holder' : 'Start Date', 'values' : ''},
            {'field' :'date', 'place_holder' : 'End Date', 'values' : ''},
            {'field' :'dropdown', 'place_holder' : 'Meeting Type', 'values' : [
                {id: "unrated", name:"Unrated"},
                {id: "rated", name:"Rated"}
              ], 'selected':'unrated'},
        ]}}
          handleFilter={handleFilter}
          setIsRemoveFilter={setIsRemoveFilter}
          // localstorageKeyRemove={'rm_list_filter'}
        />
        
      </div>
      {/* section ends */}
    </>
  );
};

export default RmList;
